// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"091a1ebb","204":"8618b53e","279":"420b6332","685":"f4adcbc3"}[chunkId] + ".chunk.js";
};